export default "__VITE_ASSET__DNOiTvqH__"